import { isObject } from "@grapecity/wijmo";

export const apiQueryParams = {
    filials: {
        default: "filialIds",
        except: "filialIdsExcept",
    },
    positions: {
        default: "postCodes",
        except: "postCodesExcept",
    },
    nameOrPhone: {
        default: "search",
    },
    analyseTypes: {
        default: "medicalAnalysesTypeIds",
        except: "medicalAnalysesTypeIdsExcept",
    },
    analyses: {
        default: "medicalAnalysesIds",
        except: "medicalAnalysesIds",
    },
    expirationTypes: {
        default: "expirationType",
    },
    expireInDaysFrom: {
        default: "expireInDaysFrom",
    },
    expireInDaysTo: {
        default: "expireInDaysTo",
    },
    hasProblem: {
        default: "hasProblem",
    },
};

const generateQueryWithIds = (key, data) => {
    const { values, except } = data;
    const ids = values.join(",");
    if (except) {
        return `${apiQueryParams[key].except}=${ids}`;
    }
    return `${apiQueryParams[key].default}=${ids}`;
};

export const generateQueryParameter = (key, data) => {
    if (!data && key !== "expireInDaysFrom") {
        return "";
    }
    if (isObject(data)) {
        return generateQueryWithIds(key, data);
    }
    return `${apiQueryParams[key].default}=${data}`;
};

export const filterAnalyseByExpirationType = {
    without_expiration: (analyse) => !analyse.expireInDays,
    with_expiration: (analyse) => analyse.expireInDays,
    expiring: (analyse) => analyse.status === "expiring",
    expired: (analyse) => analyse.status === "expired",
};
